import React from 'react';  
import './index.css';
import ImgCard from 'component/imgCard'

class InfoImg extends React.Component{
  render(){
    const {thumb, data} = this.props;

    return (
      <div className="info-img">
        <ImgCard src={thumb?thumb:''} />
        {data.model == 'require'?<img className='tipImg' src={require('./img/compulsoryCourse.png')} alt="必修课"/>:null}
        {data.model == 'select'?<img className='tipImg' src={require('./img/electiveCourse.png')} alt="必修课"/>:null}
      </div>
      )
  }
}
export default InfoImg;